import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
import { TenantState } from '../models/tenant.model';

export const selectTenantState = (state: AppState) => state.tenant;

export const selectEncryptedTenantKey = createSelector(
    selectTenantState,
    (state: TenantState) => state.isEncrypted ? state.tenantKey : null // Return tenantKey only if isEncrypted is true
);
